import request from '@/utils/request'

import { ResponseData, ResponseDataList, Search, CURD } from '../schemas'
import { ResponseRegionInfo } from '../schemas/data'

export const getList = (data: Search): Promise<ResponseDataList> => {
    return request({
        url: '/explanations/search',
        method: 'post',
        data,
    })
}

export const doAdd = (data: CURD): Promise<ResponseData> => {
    return request({
        url: '/explanations',
        method: 'post',
        data,
    })
}

export const doUpdate = (data: CURD): Promise<ResponseData> => {
    return request({
        url: '/explanations',
        method: 'put',
        data,
    })
}

export const doDelete = (data: CURD): Promise<ResponseData> => {
    return request({
        url: `/explanations/${String(data.id)}`,
        method: 'delete',
    })
}

export const getRegionInfo = (data: Search): Promise<ResponseRegionInfo> => {
    return request({
        url: `/explanations/region-info`,
        method: 'get',
        params: {
            regionType: data.regionType,
            regionId: data.regionId,
        },
    })
}
